import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col, FormGroup, FormControl, ControlLabel} from "react-bootstrap";
import Select,{Async} from "react-select";
import InlineError from "../../../messages/InlineError";

const CustomerFields = (props) => (
	<React.Fragment>
		<Row>
			<Col md={6}>
				<FormGroup validationState={props.errors.priority_level && "error"}>
					<ControlLabel>Priority Level</ControlLabel>
					<FormControl type="number" name="priority_level" placeholder="Enter Priority Level (1-10)"  value={props.formData.priority_level || ""} onChange={props.onChange} />
					{props.errors.priority_level && <InlineError text={props.errors.priority_level} />}
				</FormGroup>
			</Col>
			<Col md={6}>
				<FormGroup validationState={props.errors.pay_con_id && "error"}>
					<ControlLabel>Payment Condition</ControlLabel>
					<Select
						onChange={(option) => { props.onPaymentSelectChange(option, "pay_con_id"); }}
						name="pay_con_id"
						placeholder="Choose Payment Condition"
						value={props.selectedPayment}
						options={props.paymentConditions}
						clearable={false}
						multi={false}
					/>
					{props.errors.pay_con_id && <InlineError text={props.errors.pay_con_id} />}
				</FormGroup>
			</Col>
		</Row>
		<FormGroup validationState={props.errors.full_company_name && "error"}>
			<ControlLabel>Company Name</ControlLabel>
			<FormControl type="text" name="full_company_name" placeholder="Enter Company Name"  value={props.formData.full_company_name || ""} onChange={props.onChange} />
			{props.errors.full_company_name && <InlineError text={props.errors.full_company_name} />}
		</FormGroup>
		
		<Row>
			<Col md={6}>
				<FormGroup validationState={props.errors.administrator && "error"}>
					<ControlLabel>Administrator</ControlLabel>
					<FormControl type="text" name="administrator" placeholder="Enter Administrator Name"  value={props.formData.administrator || ""} onChange={props.onChange} />
					{props.errors.administrator && <InlineError text={props.errors.administrator} />}
				</FormGroup>
			</Col>
			<Col md={6}>
				<FormGroup validationState={props.errors.administrator_email && "error"}>
					<ControlLabel>Administrator Email</ControlLabel>
					<FormControl type="email" name="administrator_email" placeholder="Enter Administrator Email"  value={props.formData.administrator_email || ""} onChange={props.onChange} />
					{props.errors.administrator_email && <InlineError text={props.errors.administrator_email} />}
				</FormGroup>
			</Col>
		</Row>

		<Row>
			<Col md={6}>
				<FormGroup validationState={props.errors.point_of_reference_email && "error"}>
					<ControlLabel>Point of reference email</ControlLabel>
					<FormControl type="email" name="point_of_reference_email" placeholder="Enter Email"  value={props.formData.point_of_reference_email || ""} onChange={props.onChange} />
					{props.errors.point_of_reference_email && <InlineError text={props.errors.point_of_reference_email} />}
				</FormGroup>
			</Col>
			<Col md={6}>
				<FormGroup validationState={props.errors.point_of_reference_cel && "error"}>
					<ControlLabel>Point of reference cellular</ControlLabel>
					<FormControl type="text" name="point_of_reference_cel" placeholder="Enter Cellular"  value={props.formData.point_of_reference_cel || ""} onChange={props.onChange} />
					{props.errors.point_of_reference_cel && <InlineError text={props.errors.point_of_reference_cel} />}
				</FormGroup>
			</Col>
		</Row>
	</React.Fragment>
);

CustomerFields.defaultProps = {
	errors: PropTypes.object,
	selectedPayment: PropTypes.object
};

CustomerFields.propTypes = {
	formData: PropTypes.shape({
		full_company_name: PropTypes.string,
		administrator: PropTypes.string,
		administrator_email: PropTypes.string,
		point_of_reference_email: PropTypes.string,
		point_of_reference_cel: PropTypes.string,
		priority_level: PropTypes.string,
		pay_con_id: PropTypes.number,
	}).isRequired,
	errors: PropTypes.shape({
		full_company_name: PropTypes.string,
		administrator: PropTypes.string,
		administrator_email: PropTypes.string,
		point_of_reference_email: PropTypes.string,
		point_of_reference_cel: PropTypes.string,
		priority_level: PropTypes.string,
		pay_con_id: PropTypes.string,
	}),
	paymentConditions: PropTypes.arrayOf(
		PropTypes.object
	).isRequired,
	selectedPayment: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.number
	}),
	onChange: PropTypes.func.isRequired,
	onPaymentSelectChange: PropTypes.func.isRequired,
};

export default CustomerFields;


// WEBPACK FOOTER //
// ./src/components/forms/users/fields/CustomerFields.js